// extracted by mini-css-extract-plugin
module.exports = {"container":"Review_container__3cCVi","quote":"Review_quote__ebkJx","author":"Review_author__34oPj"};